import { useContext } from 'react';
import { FriendsContext } from '../contexts/FriendsContext';

export const useFriends = () => {
  const context = useContext(FriendsContext);

  if (!context) {
    throw new Error('useFriends must be used within a FriendsContextProvider');
  }

  return context;
}; 